import { AssociateFeedback, ClientFeedback } from '../../../types/feedbacks';
import AcademiaRating from '../AcademiaRating';
import AcademiaSectionWrapper from '../AcademiaSectionWrapper';
import ModalTitle from './ModalTitle';
import ParentModal from './ParentModal';

const FeedbackDetailsModal = ({
  feedback,
  handleModalClose,
  isClient,
}: {
  feedback: ClientFeedback | AssociateFeedback;
  handleModalClose: () => void;
  isClient?: boolean;
}) => {
  // rendering feedback details modal component here
  return (
    <ParentModal onClick={handleModalClose}>
      <ModalTitle titleText='feedback details' />

      <div>
        <AcademiaSectionWrapper sectionTitle='User Details'>
          <div className='flex items-center gap-2 text-base-light-blue'>
            <p>Client Name:</p>
            <p className='font-medium'>{feedback.client_full_name}</p>
          </div>

          <div className='flex items-center gap-2 text-base-light-blue'>
            <p>Associate Name:</p>
            <p className='font-medium'>{feedback.associate_full_name}</p>
          </div>
        </AcademiaSectionWrapper>

        {isClient ? (
          <AcademiaSectionWrapper sectionTitle='Ratings'>
            <AcademiaRating
              size={35}
              ratingValue={(feedback as ClientFeedback).rating}
              isReadonly
              extraClassNames='w-full truncate'
            />
          </AcademiaSectionWrapper>
        ) : null}

        <AcademiaSectionWrapper sectionTitle='Comments'>
          <p className='text-base-dark-blue'>{feedback.comments}</p>
        </AcademiaSectionWrapper>
      </div>
    </ParentModal>
  );
};

export default FeedbackDetailsModal;
